/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import Layout from 'components/Layout';
import Button, { ButtonContainer } from 'components/Button';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext } from 'store/context';
import StepNavigation from 'components/StepNavigation'
import { FormSection, FormContainer } from "@fitinsur/components";
import {
  Content,
  TitleBar,
  TitleInfo,
} from './styles';
import HasPermission from 'components/HasPermission/index';
import BrokingSummary from 'components/BrokingSummary';
import {
  LoaderContext
} from '@fitinsur/contexts';
import { 
  useGetQuestionnaireAnswer,
  useSaveQuestionnaireAnswer
} from 'services/QuestionnaireAnswerService';
import { useRequestIssueAction } from 'services/IssueService';
import { onValidationError, groupMultipleFieldQuestions } from 'containers/edit/handleQuestionChange';

const sections = {
  POLICY: { name: 'POLICY', isMultiple: false, isRisk: false },
  PARCELAMENTO: { name: 'PARCELAMENTO', isMultiple: true, isRisk: false },
  ATTACHMENTS: { name: 'ATTACHMENTS', isMultiple: false, isRisk: false }
};

export default function EditEnquirity({ permissions, ...props }) {
  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const formikRef = useRef();
  const handleBack = () => history.goBack();

  const [operation, setOperation] = useState({});
  const [questionnaire, setQuestionnaire] = useState([]);
  const [installments, setInstallments] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState('');

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  const {
    data: useSaveQuestionnaireAnswerData,
    loading: useSaveQuestionnaireAnswerLoading,
    error: useSaveQuestionnaireAnswerError,
    status: useSaveQuestionnaireAnswerStatus,
    request: useSaveQuestionnaireAnswerRequest,
} = useSaveQuestionnaireAnswer(props.match.params.idOperation);

const {
  loading: useRequestIssueActionLoading,
  request: useRequestIssueActionRequest,
} = useRequestIssueAction();

  useEffect(() => {
    useGetQuestionnairesAnswersRequest();
  }, []);

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200) {
      handleQuestionnaire(useGetQuestionnairesAnswersData?.value)
    }
  }, [useGetQuestionnairesAnswersStatus]);

  useEffect(() => {
    if (useSaveQuestionnaireAnswerStatus === 200) {
      useGetQuestionnairesAnswersRequest();
      const questionnaireAnswers = useSaveQuestionnaireAnswerData.value?.questionnaireAnswers;
      if(questionnaireAnswers?.length){
        const referenceNumber = questionnaireAnswers.find(qst => qst.idQuestion === 1216)?.textQuestionAnswer;
        const filesAnswer = questionnaireAnswers.find(qst => qst.idQuestion === 1220)?.textQuestionAnswer;
        let files = [];
        try {
          files = JSON.parse(filesAnswer);
        } catch (error) {
          console.log(error);
        }
        useRequestIssueActionRequest({
          idOperation: props.match.params.idOperation,
          files,
          referenceNumber
        }).then(async (response) => {
          if(response.status === 200){
            history.push(`/payment-pack/${props.match.params.idOperation}`)
          } else {
            mc.error('Ocorreu um erro durante a solicitação.');
          }
        })
      }
    }
}, [useSaveQuestionnaireAnswerStatus]);

  const handleQuestionnaire = (data) => {
    let questionnaire = [];
    questionnaire = [
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks
    ];
    
    questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

    questionnaire.map(qst => {
      if(qst.idQuestion === 694) qst.visibleQuestion = false;
    });

    const paymentMethodQst = questionnaire.find(qst => qst.idQuestion === 684);
    if(paymentMethodQst?.idAnswerOption){
      const option = paymentMethodQst.answerOptions.find(
        opt => opt.idAnswerOption === paymentMethodQst.idAnswerOption
      )?.dsAnswerOption;

      if(option) setPaymentMethod(` - ${option}`);
    }

    const installmentGroups = groupMultipleFieldQuestions(
      1217,
      questionnaire,
      operation,
      null
    ).map(group => { 
      group.map(qst => {
        if (qst.idQuestion === 1217) qst.disabled = true;
        return qst;
      });
      return group
    });

    setInstallments(installmentGroups);
    setQuestionnaire(questionnaire);
  }

  useEffect(() => {
    buildValidation();
  }, [questionnaire, installments]);

  useEffect(() => {
    updateIsLoadingStatus(
      useGetQuestionnairesAnswersLoading ||
      useSaveQuestionnaireAnswerLoading ||
      useRequestIssueActionLoading
    )
  }, [
    useGetQuestionnairesAnswersLoading,
    useSaveQuestionnaireAnswerLoading,
    useRequestIssueActionLoading
  ]);

  const buildValidation = () => {
    const validationSchema = {};

    const questionnaire = handleSaveQuestionnaireAnswer(formikRef?.current?.values, true);
    for (const question of questionnaire) {
      if (!question.key) continue;
      validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
        ? yup.string().required()
        : yup.string().notRequired();
    }

    return yup.object().shape(validationSchema);
  }

  const handleSaveQuestionnaireAnswer = (values, onlyQuestions) => {
    const formValues = JSON.parse(JSON.stringify(values));

    const installmentsDates = [];

    const body = { questionnaireAnswers: [] };
    for (const [key, section] of Object.entries(sections)) {
      if (section.isMultiple) {
        let multipleFields = []
        if (section.name === 'PARCELAMENTO') {
          multipleFields = installments;
        } else {
          multipleFields = [];
        }

        multipleFields.map((field, index) => {
          let sectionAnswers = formValues[`$ANSWERS_${section.name}_${index}`];
          if (sectionAnswers?.length) {
            const rootQuestion = sectionAnswers.find(question => !question.idQuestionRoot);
            const childrenQuestions = sectionAnswers.filter(question => question.idQuestionRoot);
            rootQuestion.childrenQuestions = childrenQuestions;

            if (!onlyQuestions) {
              installmentsDates.push(childrenQuestions.find(question => question.idQuestion === 1219)?.answer)
              body.questionnaireAnswers = [...body.questionnaireAnswers, rootQuestion];
            } else {
              body.questionnaireAnswers = [...body.questionnaireAnswers, ...sectionAnswers];
            }
          }
        })
      } else {
        let sectionAnswers = formValues[`$ANSWERS_${section.name}`];
        if (sectionAnswers) {
          body.questionnaireAnswers = [...body.questionnaireAnswers, ...sectionAnswers];
        }
      }
    }

    if (onlyQuestions) return body.questionnaireAnswers;

    for (const question of body.questionnaireAnswers) {
      if (
        (question.idDomainQuestion === 270 || question.idDomainQuestion === 271) && question.answer
      ) {
        if(question.idQuestion === 1220 && !question.answer.length)
          return mc.error("No mínimo um boleto deve ser anexado");
        try {
            question.answer = JSON.stringify(question.answer)
        } catch (e) {
        }
      }
    }

    const inceptionDate = questionnaire.find(qst => qst.idQuestion === 687)?.answer;
    const hasDateBefore = installmentsDates.find(v => moment(v).isBefore(moment(inceptionDate)));

    const isOrdered = installmentsDates.every((val, i, arr) => !i || (new Date(val) >= new Date(arr[i - 1])));

    if (hasDateBefore) mc.error("A data de vencimento da parcela não deve ser anterior à data de vigência da apólice");
    if (!isOrdered) mc.error("As datas de vencimento das parcelas devem ser ordenadas");

    if (hasDateBefore || !isOrdered) return;

    useSaveQuestionnaireAnswerRequest(body.questionnaireAnswers);
  }

  const onSubmit = (values) => {
    buildValidation().validate(
        values, { abortEarly: false }
    ).then(() => {
        handleSaveQuestionnaireAnswer(values)
    }).catch((e) => {
      onValidationError(e, mc, formikRef, questionnaire, [...installments])
    });
  }

  return (
    <Layout
      title={"Analise da Cotação"}
      subtitle={`${operation?.productName || ""}`}
    >
      <StepNavigation
        stage={3}
        idOperation={props.match?.params?.idOperation}
        idProduct={props.match?.params?.idProduct}
        permissions={permissions}
      />

      <BrokingSummary
        history={history}
        idOperation={props.match?.params?.idOperation}
        idProduct={props.match?.params?.idProduct} 
      />

      <Content>
        <Formik
          innerRef={formikRef}
          validateOnChange={false}
          validateOnBlur={false}
          initialValues={{}}
          enableReinitialize={true}
          onSubmit={(values) => onSubmit(values)}
        >
          {({ values, setFieldValue, errors, setFieldError }) => (
            <Form>
              <TitleBar>
                <TitleInfo>REGISTRAR NÚMERO DA APÓLICE</TitleInfo>
              </TitleBar>
              <FormContainer>
                <FormSection
                  disableAll={!permissions.ORDER_TO_BIND_APPROVE_REJECT}
                  sectionName={'POLICY'}
                  values={values}
                  errors={errors}
                  setFieldValue={setFieldValue}
                  setFieldError={setFieldError}
                  questionnaire={questionnaire}
                  formikRef={formikRef}
                  ignoreModality
                />
              </FormContainer>

              <FormContainer title={'Resumo de Parcelamento' + paymentMethod}>
                {installments && installments.map((questions, index) => (
                  <FormSection
                    disableAll={!permissions.ORDER_TO_BIND_APPROVE_REJECT}
                    key={index}
                    sectionName={'PARCELAMENTO'}
                    values={values}
                    errors={errors}
                    sectionIndex={index}
                    setFieldValue={setFieldValue}
                    setFieldError={setFieldError}
                    questionnaire={questions}
                    formikRef={formikRef}
                    ignoreModality
                  />
                ))}
              </FormContainer>

              <FormSection
                disableAll={!permissions.ORDER_TO_BIND_APPROVE_REJECT}
                sectionName={'ATTACHMENTS'}
                values={values}
                formikRef={formikRef}
                setFieldValue={setFieldValue}
                questionnaire={questionnaire}
                ignoreModality
              />

              <ButtonContainer style={{ marginTop: 60 }}>
                <Button forth style={{ width: 'auto' }} onClick={() => handleBack()}> &lt; VOLTAR </Button>
                <HasPermission permission={permissions.ORDER_TO_BIND_APPROVE_REJECT}>
                  <Button
                    id="btnSave"
                    type="submit"
                    style={{ marginLeft: 15 }}
                    secundary
                  >
                    ENVIAR
                  </Button>
                </HasPermission>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </Content>
    </Layout >
  )
}
